import { useLocation } from '#app/hooks/useLocation.js';
import {
  type Location,
  type RouterTransitionSubscriber,
} from '#app/types/router.js';
import { useMemo } from 'react';

// TODO refactor so that this is not a side-effect
globalThis.routerTransitionSubscribers = [];

export const isActive = (
  href: string,
  location: Location,
  exact: boolean = true,
) => {
  if (exact === false) {
    return (
      location.pathname.startsWith(href) ||
      // Check if the current location is a subpage of the href
      location.pathname.startsWith(`${href}/`)
    );
  }

  return location.pathname === href;
};

export const useRouter = () => {
  const location = useLocation();

  return useMemo(() => {
    return {
      isActive: (href: string, exact: boolean = true) => {
        return isActive(href, location, exact);
      },
      subscribe: (subscriber: RouterTransitionSubscriber) => {
        globalThis.routerTransitionSubscribers.push(subscriber);

        return () => {
          globalThis.routerTransitionSubscribers =
            globalThis.routerTransitionSubscribers.filter(
              (routerTransitionSubscriber) => {
                return routerTransitionSubscriber !== subscriber;
              },
            );
        };
      },
    };
  }, [location]);
};
